import mergeImages from 'merge-images';

const mergeRowLabels = async (rowLabels, width = 460, height = 170) => {
    const images = rowLabels.map((rowLabel, index) => {
        return { src: rowLabel, x: 0, y: height * index };
    });

    const options = {
        width: width,
        height: height * rowLabels.length
    };

    const b64 = await mergeImages(images, options);

    return b64;
};

export default mergeRowLabels;
